<template>
  <div class="login">
    <div class="title">欢迎使用万达商户平台</div>
    <div class="tel-code">
      <div class="tel">
        <img src="@/assets/img/dq/tel.png" />
        <div class="input">
          <input v-model="mobile" maxlength="11" type="tel" placeholder="请输入手机号" class="tel-input" />
        </div>
      </div>
      <div class="code">
        <img src="@/assets/img/dq/code.png" />
        <div class="input">
          <input v-model="verifyCode" type="tel" maxlength="6" placeholder="请输入验证码" class="tel-input" />
        </div>
        <div class="get-code" :style="{ color: seconds ? '#bbb' : '#FF6F00' }" @click="getVerifyCode">
          获取验证码<span v-if="seconds > 0">({{ seconds }}s)</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="login-btn" @click="handleLogin">登录</div>
      <div class="regist-btn" @click="goRegist">注册为万达个体商户</div>
    </div>
    <div class="notice">仅支持大陆身份证的个体商户</div>
  </div>
</template>
<script>
import { apiGetVerifyCode, apiGetUserLogin } from '@/api/dq';
import { authLogin, mobileReg } from './hooks'
const reg = mobileReg;
export default {
  data() {
    return {
      mobile: '',
      verifyCode: '',

      WXcode: '',
      seconds: 0,
      timer: 0,
    };
  },
  methods: {
    getVerifyCode() {
      if (!this.mobile || !reg.test(this.mobile))
        return this.$toast('请输入正确的手机号');
      if (this.seconds === 0) {
        this.seconds = 60;
        apiGetVerifyCode(this.mobile);
      } else return;
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          this.seconds = 0;
          clearInterval(this.timer);
          return;
        }
      }, 1000);
    },
    handleLogin() {
      if (!this.mobile || !reg.test(this.mobile))
        return this.$toast('请输入正确的手机号');
      if (!this.verifyCode) return this.$toast('请输入验证码');
      apiGetUserLogin({
        mobile: this.mobile,
        verifyCode: this.verifyCode,
        openId: localStorage.getItem('dq_openId'),
      })
        .then((res) => {

          authLogin(res, 'login', this.mobile)






          // if (userInfo.individualId || userInfo.companyTraders) {
          //   // 个体商户或管理员
          //   this.$store.commit('base/setUserInfo', userInfo);
          //   let base = JSON.stringify({
          //     token: userInfo.token,
          //     userId: userInfo.id,
          //   });
          //   this.$router.push({
          //     path: '/wxAuth/business_choice',
          //     query: {
          //       base,
          //     },
          //   });
          // } else {
          //   this.$toast('您不是个体商户或企业商户,请注册后登录');
          // }


        })
        .catch((res) => {
          this.$toast.fail(res.message);
        });
    },

    goRegist() {
      this.$router.push({ path: '/dq/agreement', query: { mobile: this.mobile } });
    },
  },
  mounted() {
    this.mobile = this.$route.query.mobile || ''
  }
};
</script>

<style lang="less">
.login {
  font-size: 14px;
  padding: 80px 20px;
  text-align: left;
  line-height: 1;

  .title {
    margin-top: 20px;
    font-size: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .tel-code {
    margin-top: 20px;
    padding: 20px 20px;

    .tel,
    .code {
      padding: 12px 0 8px;
      border-bottom: 1px solid #ffebeb;
      display: flex;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
      }

      .input {
        padding-left: 8px;
        flex: 1;
        overflow: hidden;

        input {
          padding-left: 12px;
          width: 95%;
          border: none;
          border-left: 1px solid #ffebeb;
        }

        input::-webkit-input-placeholder {
          color: #ccc;
          font-size: 14px;
        }
      }

      .get-code {
        width: 110px;
        font-size: 14px;
        font-weight: 400;
        color: #FF6F00;
        text-align: right;
      }
    }
  }

  .bottom {
    margin-top: 40px;

    .login-btn,
    .regist-btn {
      width: 100%;
      height: 44px;
      line-height: 44px;
      border-radius: 22px;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }

    .login-btn {
      color: #fff;
      background: #FF6F00;
    }

    .regist-btn {
      border: 1px solid #FF6F00;
      color: #FF6F00;
      margin-top: 20px;
    }
  }

  .notice {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }
}
</style>

